import React from "react"

interface SpaceType {
  top?: number
  bottom?: number
  left?: number
  right?: number
}

const GetSpace: React.FC<SpaceType> = ({ top = 0, bottom = 0, left = 0, right = 0 }) => {
  return (
    <div
      style={{
        marginTop: `${top}px`,
        marginBottom: `${bottom}px`,
        marginLeft: `${left}px`,
        marginRight: `${right}px`,
      }}
    ></div>
  )
}

export default GetSpace
